var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurveOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "svg",
    viewBox: "0 0 1440 600",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transition duration-300 ease-in-out delay-150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,600 C 0,600 0,300 0,300 C 119.87559808612443,317.1387559808612 239.75119617224885,334.2775119617225 334,317 C 428.24880382775115,299.7224880382775 496.87081339712915,248.02870813397126 581,232 C 665.1291866028708,215.97129186602874 764.7655502392345,235.60765550239233 855,261 C 945.2344497607655,286.39234449760767 1026.066985645933,317.5406698564594 1122,325 C 1217.933014354067,332.4593301435406 1328.9665071770335,316.22966507177034 1440,300 C 1440,300 1440,600 1440,600 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "#eb144cff",
    className: "transition-all duration-300 ease-in-out delay-150 path-0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveOne);
export default __webpack_public_path__ + "static/media/CurveOne.65df7f5546201dae90de63cd6f004c61.svg";
export { ForwardRef as ReactComponent };